import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { connect } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { Toast } from 'primereact/toast';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { RadioButton } from 'primereact/radiobutton';
import { Checkbox } from 'primereact/checkbox';
import Messages from '../../../shared/UI/Messages/Messages';
import axios from '../../../axios-url';


import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { Companyid, DROPDOWN_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';

class AddPropertyGroup extends Component {
    state = {
        roles: [],
        type: 'add',
        Id: null,
        PropertyGroupId: '',
        PropertyGroupName: '',
        // PropertyGroupType: '',
        // TenantZone: '',
        Address: '',
        City: '',
        State: '',
        Country: '',
        ZipCode: '',
        ConstructionDetails: '',
        OtherNotes: '',
        MeasurementsType: '',
        GrossArea: '',
        NetArea: '',
        NumberOfBedSpace: '',
        LandArea: '',
        IsActive: false,
        touch: false,
        CompanyId: this.props.loggedUserDetail.CompanyId,

    }

    // componentDidMount() {
    //     this.getAccess = HASACCESS(USER_SUBMENU_ID);
    //     const type = this.props.match.params.type;
    //     const id = this.props.match.params.id;
    //     // this.props.getMasterKeywordList("TenantZone");
    //     this.props.getMasterKeywordList("Country");


    //     // axios.get('/master/api/DropDownValues/FRole')
    //     //     .then(response => {
    //     //         if (response.status === 200) {
    //     //             let data = []
    //     //             if (response.data && response.data.length > 0) {
    //     //                 data = response.data.map(list => {
    //     //                     let value = list.id;
    //     //                     let id = list.id;
    //     //                     let text = list.text
    //     //                     return { label: text, value: value.toString(), id: id };
    //     //                 })
    //     //             }
    //     //             this.setState({ functionalRoleOptions: data })
    //     //         }
    //     //     }
    //     //     )
    //     //     .catch(err => {
    //     //         this.growl.show({ severity: 'error', summary: null, detail: 'Functional Roles Api Failed' });
    //     //     })

    //     if (type !== 'add') {
    //         // this.timer();
    //         this.props.getMasterTableList(
    //             `res/GetPropertyGroupbyid?propertygroupId=${id}`, this.state.CompanyId
    //         );
    //     }
    // }

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);

        const type = this.props.match.params.type;
        const id = this.props.match.params.id;

        this.setState({ type: type });

        this.props.getMasterKeywordList("Country");

        if (type !== "add" && id) {
            this.props.getMasterTableList(
                `res/GetPropertyGroupbyid?propertygroupId=${id}`, this.state.CompanyId
            );
        }
    }

    // componentDidUpdate(prevProps) {

    //     if (
    //         this.props.tableLists &&
    //         this.props.tableLists !== prevProps.tableLists
    //     ) {

    //         const propertygroup = this.props.tableLists;

    //         this.setState({

    //             PropertyGroupId: propertygroup.propertygroupId,
    //             PropertyGroupName: propertygroup.propertygroupName,
    //             // PropertyGroupType: propertygroup.propertygroupType,
    //             // TenantZone: propertygroup.tenantzone,
    //             Address: propertygroup.address,
    //             City: propertygroup.city,
    //             State: propertygroup.state,
    //             Country: propertygroup.country,
    //             ZipCode: propertygroup.zipCode,
    //             ConstructionDetails: propertygroup.constructionalDetail,
    //             OtherNotes: propertygroup.otherNotes,
    //             MeasurementsType: propertygroup.measurementsType,
    //             GrossArea: propertygroup.grossArea,
    //             NetArea: propertygroup.netArea,
    //             NumberOfBedSpace: propertygroup.numberofbed,
    //             LandArea: propertygroup.landArea,
    //             IsActive: propertygroup.active,


    //         });
    //     }
    // }

    // componentDidUpdate(prevProps) {

    //     if (
    //         this.props.tableLists !== prevProps.tableLists &&
    //         this.props.tableLists
    //     ) {

    //         const asset = Array.isArray(this.props.tableLists)
    //             ? this.props.tableLists[0]
    //             : this.props.tableLists;

    //         if (!asset) return;

    //         this.setState({
    //             Id: asset.assetId,
    //             AssetNumber: asset.assetCode || "",
    //             AssetName: asset.assetName || "",
    //             SerialNumber: asset.serialNumber || "",
    //             CompanyId: asset.companyid,
    //             ResponsibleDepartment: asset.department,
    //             Location: asset.currentLocation || "",
    //             StartDate: asset.purchaseDate ? new Date(asset.purchaseDate) : null,
    //             EmployeeId: asset.employeeId,
    //             CategoryId: asset.assetCategory,
    //             Remarks: asset.remark || "",
    //             IsActive: asset.isActive,
    //             DepreciationApplicable: asset.depreciationApplicable,
    //             DepreciationMethod: asset.depreciationMethod,
    //             WarrantyStartDate: asset.warrantyStartDate ? new Date(asset.warrantyStartDate) : null,
    //             WarrantyEndDate: asset.warrantyEndDate ? new Date(asset.warrantyEndDate) : null,
    //             AMCStartDate: asset.amcstartDate ? new Date(asset.amcstartDate) : null,
    //             AMCEndDate: asset.amcendDate ? new Date(asset.amcendDate) : null,
    //             ServiceVendor: asset.serviceVendor,
    //             dataFetched: true
    //         });
    //     }
    // }

    componentDidUpdate(prevProps) {

        if (
            this.props.tableLists !== prevProps.tableLists &&
            this.props.tableLists
        ) {

            const property =
                Array.isArray(this.props.tableLists)
                    ? this.props.tableLists[0]
                    : this.props.tableLists;

            if (!property) return;

            this.setState({

                // Id: property.propertygroupId,

                PropertyGroupId: property.propertygroupId || "",
                PropertyGroupName: property.propertygroupName || "",
                Address: property.address || "",
                City: property.city || "",
                State: property.state || "",
                Country: property.country || "",
                ZipCode: property.zipCode || "",
                ConstructionDetails: property.constructionalDetail || "",
                OtherNotes: property.otherNotes || "",
                MeasurementsType: property.measurementsType || "",
                GrossArea: property.grossArea || "",
                NetArea: property.netArea || "",
                NumberOfBedSpace: property.numberofbed || "",
                LandArea: property.landArea || "",
                IsActive: property.active,
                touch: false

            });

        }

    }


    // change = (e) => {
    //     let { name, value } = e.target;
    //     this.setState({ [name]: value, touch: true })

    // }

    // timer = () => {
    //     this.intervalID = setInterval(() => {
    //         this.fetchSingleProcess();
    //     }, 2000)
    // }
    // componentWillUnmount() {
    //     if (this.props.tableLists.usersList !== undefined) {
    //         clearInterval(this.intervalID);
    //     }
    // }

    // fetchSingleProcess = () => {

    //     let id = this.props.match.params.id;
    //     let type = this.props.match.params.type;
    //     let storageItems = [];
    //     if (this.props.tableLists.usersList !== undefined) {
    //         storageItems = this.props.tableLists.users;
    //         clearInterval(this.intervalID);
    //     }
    //     if (storageItems) {
    //         let filterData = storageItems;
    //         if (filterData) {
    //             let roles = '';
    //             let functionalRoles = '';
    //             let approvalroles = '';
    //             if (filterData.roleAssigned != null) {
    //                 roles = filterData.roleAssigned.split(",")
    //             }
    //             if (filterData.functionalRole != null) {
    //                 functionalRoles = filterData.functionalRole.split(",")
    //             }
    //             if (filterData.approvalrole != null) {
    //                 approvalroles = filterData.approvalrole.split(",")
    //             }
    //             var data = {
    //                 type: type,
    //                 Id: filterData.id,
    //                 UserId: filterData.userId,
    //                 EmployeeId: filterData.employeeId,
    //                 RoleId: roles,
    //                 approvalRoleId: approvalroles,
    //                 UserId1: filterData.userid1,
    //                 FirstName: filterData.firstName,
    //                 functionalRoleId: functionalRoles,
    //                 MiddleName: filterData.middleName,
    //                 LastName: filterData.lastName,
    //                 EmailId: filterData.emailId,
    //                 Password: filterData.password,
    //                 MobileNumber: filterData.mobileNumber,
    //                 Activedirectory: filterData.activedirectory,
    //                 Adloginid: filterData.adloginid,
    //                 Disablelogin: filterData.disablelogin,
    //                 IsActive: filterData.isActive,
    //                 CreatedBy: filterData.createdby,
    //                 CreatedDate: filterData.createddate,
    //             }
    //             this.setState(data);

    //         }
    //     }

    // }


    // change = (e) => {
    //     let { name, value } = e.target;
    //     this.setState({ [name]: value, touch: true })

    // }
    // change = (e) => {
    //     let { name, value, checked, type } = e.target;

    //     // Handle different input types
    //     if (type === 'checkbox' || type === 'switch') {
    //         this.setState({ [name]: checked, touch: true });
    //     } else {
    //         this.setState({ [name]: value, touch: true });
    //     }
    // }

    // Handle dropdown change
    // onDropdownChange = (e) => {
    //     const { name, value } = e.target;
    //     this.setState({ [name]: value, touch: true });
    // }

    change = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
            touch: true
        });
    }

    onDropdownChange = (e) => {
        this.setState({
            [e.target.name]: e.value,
            touch: true
        });
    }

    

    add = () => {

        if (this.state.EmployeeId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Employee is required' });
            return;
        } else if (this.state.RoleId === null || this.state.RoleId === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Role is required' });
            return;
        }

        else if (this.state.UserId1 === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'UserName is required' });
            return;
        } else if (this.state.FirstName === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'FirstName is required' });
            return;
        } else if (this.state.LastName === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'LastName is required' });
            return;
        } else if (this.state.EmailId === "" || this.state.EmailId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'EmailId is required' });
            return;
        } else if (this.state.Password === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'Password is required' });
            return;
        } else if (this.state.MobileNumber === "" || this.state.MobileNumber === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'MobileNumber is required' });
            return;
        } else if (this.state.approvalRoleId === "" || this.state.approvalRoleId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Approval Roleid is required' });
            return;
        } else if (this.state.functionalRoleId === "" || this.state.functionalRoleId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'functional Roleid is required' });
            return;
        }
        var data = {

            // propertygroupId: this.state.PropertyGroupId,
            propertygroupName: this.state.PropertyGroupName,
            companyid: this.state.CompanyId,
            // propertygroupType: this.state.PropertyGroupType,
            // tenantzone: this.state.TenantZone,
            address: this.state.Address,
            city: this.state.City,
            state: this.state.State,
            country: this.state.Country,
            zipCode: this.state.ZipCode,
            constructionalDetail: this.state.ConstructionDetails,
            otherNotes: this.state.OtherNotes,
            measurementsType: this.state.MeasurementsType,
            grossArea: this.state.GrossArea,
            netArea: this.state.NetArea,
            numberofbed: this.state.NumberOfBedSpace,
            landArea: this.state.LandArea,
            active: this.state.IsActive,

        }


        if (this.state.type === 'edit') {
            data.propertygroupId = this.state.PropertyGroupId;
            // data.Id = this.state.Id
        }

        this.props.processDynamicData('propertygroup', this.state.type, data, 'res/GetPropertyGroupbyid?' + Companyid);
        console.log(data);
    }

    resetData = () => {
        var data = {
            // roles: [],
            type: 'add',
            // Id: null,
            PropertyGroupId: '',
            PropertyGroupName: '',
            // PropertyGroupType: '',
            // TenantZone: '',
            Address: '',
            City: '',
            State: '',
            Country: '',
            ZipCode: '',
            ConstructionDetails: '',
            OtherNotes: '',
            MeasurementsType: '',
            GrossArea: '',
            NetArea: '',
            NumberOfBedSpace: '',
            LandArea: '',
            IsActive: false,
            touch: false
        }
        this.setState(data);
    }

    render() {
        if (this.props.success) {
            REDIRECT_TO_URL('/PropertyGroup/', this.props);
        }



        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false && this.props.userDetail.userId !== this.props.match.params.id) { this.props.history.push('/dashboard') }
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess: addAccess, editAccess: editAccess }

        let roleOptions = [];
        if (this.props.Role && this.props.Role.length > 0) {
            roleOptions = this.props.Role;
        }
        let approvalroleOptions = [];
        if (this.props.ApprovalRole && this.props.ApprovalRole.length > 0) {
            approvalroleOptions = this.props.ApprovalRole;
        }

        let isEnabled = (this.state.touch === true);

        let redirectURL = '/PropertyGroup/';
        if (this.props.userDetail && this.props.match.params.id !== undefined) {
            if (this.props.userDetail.userId === this.props.match.params.id) {
                redirectURL = "/dashboard";
            }
        }

        const { id, name, label, value, placeholder, fieldStatus, onInputChange, disabled, style } = this.props;


        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>Add Property Group</h1>

                        <div className="p-grid mt1">

                            <div className="p-col-6 p-offset-3">

                                {/* <div className="p-col-12">
                                    <label htmlFor="acSimple">Property Group ID <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="PropertyGroupId" placeholder="Property Group ID" value={this.state.PropertyGroupId} onChange={this.change} disabled={this.state.type === 'view'}
                                    />
                                </div> */}

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Property Group Name <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="PropertyGroupName" placeholder="Property Group Name" value={this.state.PropertyGroupName} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                {/* <div className="p-col-12">
                                    <label htmlFor="acSimple">Property Type  <span className="requiredColor">*</span></label>
                                </div> */}
                                {/* <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" name="PropertyGroupType" placeholder="Property Type" options={this.props.PropertyGroupType} value={this.state.PropertyGroupType} name="PropertyGroupType" onChange={this.change} {...DROPDOWN_CONFIG} />
                                </div> */}

                                {/* <div className="p-col-12">
                                    <label htmlFor="acSimple">Tenant Zone <span className="requiredColor">*</span></label>
                                </div> */}
                                {/* <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" name="TenantZone" placeholder="Tenant Zone" options={this.props.TenantZone
                                    } value={this.state.TenantZone} name="TenantZone" onChange={this.change} {...DROPDOWN_CONFIG} />
                                </div> */}

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Address Line <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="Address" placeholder="Address Line" value={this.state.Address} onChange={this.change} disabled={this.state.type === 'view'}
                                    />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">City <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="City" placeholder="City" value={this.state.City} onChange={this.change} disabled={this.state.type === 'view'}
                                    />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">State <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="State" placeholder="State" value={this.state.State} onChange={this.change} disabled={this.state.type === 'view'}
                                    />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Country <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" name="Country" placeholder="Country" options={this.props.Country} value={this.state.Country} onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} />
                                </div>


                                <div className="p-col-12">
                                    <label htmlFor="acSimple"> Zip<span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="ZipCode" placeholder="Zip" value={this.state.ZipCode} onChange={this.change} disabled={this.state.type === 'view'}
                                    />
                                </div>

                                <div className="p-col-12">
                                    <div className="p-col-12">
                                        <label htmlFor="details">Construction Details</label>
                                    </div>
                                    <div className="p-col-12">
                                        <textarea
                                            rows="4"
                                            name="ConstructionDetails"
                                            id="details"
                                            value={this.state.ConstructionDetails}
                                            onChange={this.change}
                                            placeholder="Construction Details"
                                            className="p-col-12 p-inputtext"
                                            autoComplete="off"
                                            style={{ resize: 'vertical' }}
                                            disabled={this.state.type === 'view'}
                                        ></textarea>
                                    </div>
                                </div>

                                <div className="p-col-12">
                                    <div className="p-col-12">
                                        <label htmlFor="details">Other Notes</label>
                                    </div>
                                    <div className="p-col-12">
                                        <textarea
                                            rows="4"
                                            name="OtherNotes"
                                            id="details"
                                            value={this.state.OtherNotes}
                                            onChange={this.change}
                                            placeholder="Other Notes"
                                            className="p-col-12 p-inputtext"
                                            autoComplete="off"
                                            style={{ resize: 'vertical' }}
                                            disabled={this.state.type === 'view'}

                                        ></textarea>
                                    </div>
                                </div>

                                <div className="p-col-12 p-md-6 p-lg-4">
                                    <label className="labeltop" htmlFor="textarea">Measurements<span className="requiredColor">*</span></label>
                                    <div className="p-grid" style={{ marginTop: '0.5em' }}>
                                        <div className="p-col-12 p-md-6">
                                            {/* <RadioButton value="male" name="Gender" onChange={event => this.setState({ Gender: 1 })} checked={this.state.Gender === 1 || this.state.Gender === "1"} /> */}


                                            <RadioButton
                                                value={1}
                                                checked={this.state.MeasurementsType === 1}
                                                onChange={(e) => this.setState({
                                                    MeasurementsType: e.value,
                                                    touch: true
                                                })}
                                            />


                                            <label htmlFor="rb1" className="p-radiobutton-label">Feet/Sq.Feet</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                            {/* <RadioButton value="female" name="Gender" onChange={event => this.setState({ Gender: 2 })} checked={this.state.Gender === 2 || this.state.Gender === "2"} /> */}
                                            <RadioButton
                                                value={2}
                                                checked={this.state.MeasurementsType === 2}
                                                onChange={(e) => this.setState({
                                                    MeasurementsType: e.value,
                                                    touch: true
                                                })}
                                            />
                                            <label htmlFor="rb1" className="p-radiobutton-label">Meter/Sq.Meter</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple"> Gross Floor Area<span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="GrossArea" placeholder="Gross Floor Area" value={this.state.GrossArea} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple"> Net Lat- Area<span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="NetArea" placeholder="Net Lat- Area" value={this.state.NetArea} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Number of Bed Space<span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="NumberOfBedSpace" placeholder="Number of Bed Space" value={this.state.NumberOfBedSpace} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Land Area<span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="LandArea" placeholder="Land Area" value={this.state.LandArea} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12" style={style ? style : { marginTop: '38px' }}>
                                    {/* <Checkbox
                                        name={name}
                                        inputId="applyLateFee"
                                        value={value}
                                        disabled={disabled}
                                        onChange={(e) => this.setState({ applyLateFee: e.checked, touch: true })}
                                        checked={this.state.applyLateFee} /> */}
                                    <Checkbox
                                        inputId="IsActive"
                                        checked={this.state.IsActive}
                                        onChange={(e) =>
                                            this.setState({
                                                IsActive: e.checked,
                                                touch: true
                                            })
                                        }
                                        disabled={this.state.type === 'view'}

                                    />
                                    <label htmlFor="applyLateFee" className="p-checkbox-label">Active</label>
                                </div>


                                {/* <div className="p-col-12">
                                    <label htmlFor="acSimple">Status :</label>
                                </div>
                                <div className="p-col-12">
                                    <InputSwitch checked={this.state.IsActive} onChange={this.change} name="IsActive" value={this.state.IsActive} />
                                </div> */}
                            </div>
                            <div className="p-col-12 p-lg-12">

                                <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData} to={redirectURL} />

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        userPref: state.auth.userPref,
        GetEmployeedropdown: (state.keyword.Employee !== undefined) ? state.keyword.Employee : [],
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        Role: (state.keyword.Role !== undefined) ? state.keyword.Role : [],
        ApprovalRole: (state.keyword.ApprovalRole !== undefined) ? state.keyword.ApprovalRole : [],
        // TenantZone: (state.keyword.TenantZone !== undefined) ? state.keyword.TenantZone : [],
        Country: (state.keyword.Country !== undefined) ? state.keyword.Country : [],
        tableLists: state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table, companyid) => dispatch(actions.getMasterTableList(table, companyid)),
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists: (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddPropertyGroup);